import PropTypes from 'prop-types'
import format from 'date-fns/format' // see https://date-fns.org/v2.25.0/docs/format for examples
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict'
import isToday from 'date-fns/isToday'
import isYesterday from 'date-fns/isYesterday'

const ElapsedTime = ({ element, date, includeTime = false }) => {
  const Element = element
  const dateFromUnix = new Date(date * 1000)
  let formattedDate = ''

  if (isToday(dateFromUnix)) {
    formattedDate = `${formatDistanceToNowStrict(dateFromUnix)} ago`
  } else if (isYesterday(dateFromUnix)) {
    formattedDate = `Yesterday, ${format(
      dateFromUnix,
      !includeTime ? 'd LLL' : 'p'
    )}`
  } else {
    formattedDate = format(
      dateFromUnix,
      !includeTime ? 'iii, d LLL' : 'p, d LLL'
    )
  }

  return Element ? <Element>{formattedDate}</Element> : formattedDate
}

ElapsedTime.propTypes = {
  element: PropTypes.element,
  date: PropTypes.number.isRequired,
  includeTime: PropTypes.bool
}

export default ElapsedTime
